<template>
    <v-card  
        :to="(data.button.route && data.button.target != '_blank')  ? data.button.route : null" 
        :href="(data.button.target == '_blank')  ?  data.button.link : null" 
        :target="data.button.target"    
        class="w-100 h-100 bg-black" 
        :class="data.class" 
        data-aos="fade-right" 
        rounded="0">
        <v-row no-gutters class="fill-height">
            <v-col cols="4">
                <v-img
                    :lazy-src="data.image.sizes.thumbnail"
                    lazy
                    :src="data.image.sizes.full"
                    cover
                    :alt="data.image.title+' - '+data.image.description"
                    class="mx-auto w-100 h-100"
                ></v-img>
            </v-col>
            <v-col cols="8" class="pa-5">
                <v-row align-center no-gutters class="fill-height">
                    <v-col cols="12" class="py-3">
                        <h2 class="text-h5 ">{{ data.title }}</h2>
                        <h3 v-if="data.sub_title">{{ data.sub_title }}</h3>
                    </v-col>
                    <v-col cols="12">
                        <v-progress-linear height="2" color="primary" model-value="100"></v-progress-linear>  
                    </v-col>
                    <v-col cols="12" class="py-3">
                        {{ data.text }}
                    </v-col>
                    <v-col cols="12" data-aos-delay="50" v-if="data.has_button" class="text-end">
                        <v-hover>
                            <template v-slot:default="{ isHovering, props }">
                                <v-btn 
                                    @click="goToLink(data.button)" 
                                    class="btn-primelinks text-primary bg-transparent" 
                                    v-bind="props"
                                    variant="text" 
                                    :class="isHovering ? '' : ''" 
                                    :color="data.button.color">
                                    <span class="text-underline">{{data.button.text}}</span>
                                    <v-icon class="ms-3">{{data.button.icon}}</v-icon>
                                </v-btn>
                            </template>
                        </v-hover>
                    </v-col>
                </v-row>
                <!-- <pre>{{ data }}</pre> -->
            </v-col>
        </v-row>
    </v-card>
</template>

<script>
export default{
    props:{
        data:{
            required: true,
            type: Object,
        }
    },
    mounted(){
   
    },
    methods:{
        goToLink(button){


            if(button.target == '_blank'){
                window.open(button.link, "_blank");
            }else{
                if(button.route){
                    this.$router.push(button.route);
                }else{
                    this.$router.push(button.link);
                }
            }
            
            
        }
    }
}
</script>